import { FC, useEffect, useRef } from 'react';
import { isMainnet } from 'utils';

import './Modal.scss';

import TestnetImg from 'assets/images/modal-banner-testnet.svg';
import MainnetImg from 'assets/images/modal-baner-mainnet.svg';
import TestnetImgMob from 'assets/images/modal-banner-testnet-mob.png';
import MainnetImgMob from 'assets/images/modal-baner-mainnet-mob.svg';
import ModalBannerMob from 'assets/images/modal-banner-mobile.svg';
import mainLogo from 'assets/images/main-logo.svg';

interface Props {
  children: any;
  handlerClose?: Function;
  hideCloseBtn?: boolean;
}

const Modal: FC<Props> = ({ children = '', handlerClose = () => {}, hideCloseBtn = false }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (event: any) => {
      const myBox = document.getElementsByClassName('welcome-modal')[0];
      if (event?.target.contains(myBox) && event?.target !== myBox) {
        handlerClose();
      }
    };

    const element = ref.current as unknown as Element;
    element.addEventListener('click', handleClick);

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div className="welcome-modal-overlay" ref={ref}>
      <div className="welcome-modal">
        <div className="welcome-modal-logo">
          <img src={mainLogo} alt="logo" />
        </div>
        {!hideCloseBtn && (
          <span className="welcome-modal-close-btn" onClick={() => handlerClose()}>
            X
          </span>
        )}
        <div className="welcome-modal-content-wr">{children}</div>

        <div
          className="welcome-modal-image"
          style={{
            backgroundImage: `url(${
              isMainnet()
                ? window.innerWidth >= 768
                  ? MainnetImg
                  : ModalBannerMob
                : window.innerWidth >= 768
                ? TestnetImg
                : ModalBannerMob
            })`,
          }}
        >
          <p className="welcome-modal-mob-text">
            <span className="welcome-modal-mob-text-1">Cables</span>
            <span className="welcome-modal-mob-text-2">Finance</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
